import { FC } from 'react';
import styled from '@emotion/styled';
import { GlobalHeader } from 'components/_global/header/GlobalHeader';
import AppNav from 'components/account/app-nav/AppNav';
import { mediaDesktop } from 'components/core/theme/breakpoints';
import { BodyNoNav, BodyWithNavNoFooter } from 'components/structure/body';
import { useBrowserContext } from 'contexts/BrowserContext';
import { useCurrentUser } from 'contexts/CurrentUserContext';
import { useEnsureAuthenticated } from 'hooks/useEnsureAuthenticated';
import { Outlet } from 'react-router-dom';

import { AppNavHolder } from '../home/Styles';

interface Props {
  hideNav?: boolean;
}

const Content = styled.div`
  grid-area: body;

  ${mediaDesktop} {
    padding-right: 16px;
  }
`;

export const HomeLayout: FC<Props> = props => {
  useEnsureAuthenticated();
  const { isMobileView } = useBrowserContext();
  const user = useCurrentUser();

  return props.hideNav ? (
    <>
      <GlobalHeader user={user.state.account} isMobileView={isMobileView} />
      <BodyNoNav>
        <Content>
          <Outlet />
        </Content>
      </BodyNoNav>
    </>
  ) : (
    <>
      <GlobalHeader user={user.state.account} isMobileView={isMobileView} />
      <BodyWithNavNoFooter>
        <AppNavHolder>
          <AppNav />
        </AppNavHolder>

        <Content>
          <Outlet />
        </Content>
      </BodyWithNavNoFooter>
    </>
  );
};
